<template>
  <div class="row mt-4">
    <div class="flex md8" v-if="listImg.length > 0">
      <div class="row row-inside">
        <div class="flex md12">
          <div style="position: relative;">
            <va-button
              @click="showPrevImage"
              icon="fa fa-chevron-left"
              flat
              style="position: absolute; top: 50%;"
            />
            <va-button
              @click="showNextImage"
              icon="fa fa-chevron-right"
              flat
              style="position: absolute; top: 50%; right: 0;"
            />
            <div style="display: block; text-align: center; transition: all  2s;">
              <img
                :src="getUrlImg(listImg[currImage])"
                style="min-height: 50vh; height: 50vh; max-width: 100%;"
              />
            </div>
          </div>
        </div>
        <div class="flex md12 ma-4">
          <p>{{ listImg[currImage].commentaire }}</p>
        </div>
      </div>
    </div>
    <div class="flex md8" v-else>Aucune image disponible</div>
    <div class="flex md4">
      <div class="row row-inside">
        <div class="flex md12">
          <div class="row">
            <template v-for="image in listImg">
              <div class="flex md4 pa-2" v-on:click="switchImage(image)">
                <va-card titleOnImage :image="getUrlThumb(image)" class="thumbnail">
                  <template slot="header">
                    <va-button
                      flat
                      icon="fa fa-edit"
                      color="primary"
                      class="button-edit"
                      @click="editImage(image)"
                    />
                    <va-button
                      flat
                      icon="fa fa-trash"
                      color="primary"
                      class="button-delete"
                      @click="deleteImage(image)"
                    />
                  </template>
                </va-card>
              </div>
            </template>
          </div>
        </div>
        <div class="flex md12">
          <va-button class="ml-3" color="info" @click="addPhoto" icon="fa fa-plus" />Ajouter une image
        </div>
      </div>
    </div>
    <va-modal
      title="Nouvelle image"
      class="modal"
      v-model="showUploadForm"
      cancelClass="none"
      okText="Sauvegarder"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="uploadImage"
      v-on:cancel="closeUploadForm"
    >
      <div class="row row-inside">
        <div class="flex md12">
          <va-file-upload
            type="single"
            color="info"
            dropzone
            v-model="newImage"
            fileTypes=" .png, .jpg, .jpeg"
          />
        </div>
        <div class="flex md12 mt-4">
          <va-input
            v-model="newComment"
            label="Commentaire:"
            type="textarea"
            autosize
            :minRows="4"
            :maxRows="7"
          />
        </div>
      </div>
    </va-modal>
    <va-modal
      title="Modifier la légende"
      class="modal"
      v-model="showModify"
      cancelClass="none"
      okText="Sauvegarder"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="modifyImage"
      v-on:cancel="closeModify"
    >
      <div class="row row-inside">
        <div class="flex md12 mt-4">
          <va-input
            v-model="changeComment"
            label="Commentaire:"
            type="textarea"
            autosize
            :minRows="4"
            :maxRows="7"
          />
        </div>
      </div>
    </va-modal>
    <va-modal
      title="Suppression de l'image"
      class="modal"
      v-model="showDelete"
      cancelClass="none"
      okText="Supprimer"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="confirmDelete"
      v-on:cancel="cancelDelete"
    >
      <div class="row row-inside">
        <div class="flex md12">
          <p>Supprimer l'image?</p>
        </div>
      </div>
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";
import { findIndex, debounce, cloneDeep } from "lodash";

export default {
  name: "galerie",
  props: ["identreprise"],

  data() {
    return {
      showModify: false,
      changeComment: "",
      currImage: 0,
      listImg: [],
      showUploadForm: false,
      newImage: [],
      newComment: "",
      isaction: false,
      toDelete: null,
      showDelete: false,
      toModify: null
    };
  },
  mounted() {
    this.loadGalerie();
  },
  methods: {
    async modifyImage() {
      try {
        if (this.toModify) {
          this.toModify.commentaire = this.changeComment;
          await axios.put("api/galerie/update", { image: this.toModify });

          let index = findIndex(this.listImg, {
            idimage: this.toModify.idimage
          });

          this.listImg[index] = cloneDeep(this.toModify);

          this.toModify = null;
          this.changeComment = "";

          this.launchEpicmaxToast("Commentaire mis à jour");
        } else {
          throw "no image";
        }
      } catch (error) {
        this.launchEpicmaxToast("Erreur lors de la modification");
      }
    },
    closeModify() {
      this.toModify = null;
      this.changeComment = "";
    },
    async confirmDelete() {
      try {
        if (this.toDelete) {
          await axios.delete("api/galerie/image", {
            params: { image: this.toDelete }
          });

          let index = findIndex(this.listImg, {
            idimage: this.toDelete.idimage
          });
          this.$delete(this.listImg, index);

          this.launchEpicmaxToast("Image supprimée");
        } else {
          throw "no image";
        }
      } catch (error) {
        this.launchEpicmaxToast("Erreur lors de la suppression");
      }
      this.toDelete = null;
    },
    cancelDelete() {
      this.toDelete = null;
      this.showDelete = false;
    },
    deleteImage(image) {
      //prevent switch of image
      this.isaction = true;
      this.toDelete = image;
      this.showDelete = true;
    },
    editImage(image) {
      this.isaction = true;
      this.toModify = image;
      this.changeComment = image.commentaire;
      this.showModify = true;
    },
    switchImage: debounce(function(image) {
      if (this.isaction) {
        this.isaction = false;
        return;
      }
      let index = findIndex(this.listImg, {
        idimage: image.idimage
      });
      this.currImage = index;
      console.log(index);
    }, 100),

    showPrevImage() {
      this.currImage = !this.currImage
        ? this.listImg.length - 1
        : this.currImage - 1;
    },
    showNextImage() {
      this.currImage =
        this.currImage === this.listImg.length - 1 ? 0 : this.currImage + 1;
    },
    getUrlThumb(image) {
      return "/thumbnails/" + image.idimage + ".jpg";
    },
    getUrlImg(image) {
      return "/images/" + image.idimage + ".jpg";
    },
    addPhoto() {
      this.showUploadForm = true;
    },
    async loadGalerie() {
      try {
        let res = await axios.get("/api/galerie/list", {
          params: { identreprise: this.identreprise }
        });

        this.listImg = res.data;
        console.log(this.listImg);
      } catch (error) {}
    },
    async uploadImage() {
      this.showUploadForm = true;

      if (this.newImage.length > 0 && this.identreprise) {
        let formData = new FormData();
        formData.append("image", this.newImage[0]);
        let res = await axios.post("/api/galerie/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          },
          params: {
            identreprise: this.identreprise,
            commentaire: this.newComment
          }
        });

        this.listImg.push(res.data);
        this.closeUploadForm();
      }
    },
    closeUploadForm() {
      this.showUploadForm = false;
      this.newImage = [];
      this.newComment = "";
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000
      });
    }
  },
  watch: {
    identreprise(newid) {
      if (newid) {
        this.loadGalerie();
      } else {
      }
    }
  },
  computed: {}
};
</script>

<style lang="scss">
.thumbnail {
  height: 8rem;
}

.thumbnail:hover {
  cursor: pointer;
}

.button-edit {
  position: relative;
  top: -5em;
  left: -1.5em;
}
.button-delete {
  position: relative;
  top: -5em;
  left: -3em;
}
</style>
